import classNames from "classnames";
import { If } from "react-conditional-components-renderer";
import { NotificationBellIcon } from "../../AscIcons";
import AscButton, { AscButtonProps } from "../AscButton";

import styles from "./AscMenuIconButton.module.scss";

export interface AscMenuIconButtonProps extends AscButtonProps {
  count?: number;
  children?: React.ReactNode;
}

export default function AscMenuIconButton({
  count = 0,
  children,
  className,
  ...rest
}: AscMenuIconButtonProps) {
  return (
    <AscButton
      variant="white"
      icon={children || <NotificationBellIcon />}
      className={classNames(styles.ground, className, {
        [styles.small]: rest?.size === "small",
      })}
      {...rest}
    >
      <If test={count > 0}>
        <span className={styles.count}>{count > 99 ? "99+" : count}</span>
      </If>
    </AscButton>
  );
}
